import { UserFeatureBundlesQueryDocument as __graphqlDocument0 } from 'store/client/documents/UserFeatureBundlesQueryDocument'; 

export const userFeatureBundlesQuery = __graphqlDocument0




























;
